import {logger as SentryLogger} from '@sentry/react';
import {IVehicle} from "@services/Vehicles/Vehicles";

export type ExchangeVehicle = {
  id: string;
  make: string;
  model: string;
  year: string;
  color: string;
  license_plate: string;
  vin: string;
  current_meter_value: number;
  body_type: string;
  group_ancestry: string;
  // Current Fleetio status. Used to spot a vehicle out on a DAMS cross hire, which is what makes
  // an otherwise ordinary Permanent exchange a DAMS return.
  vehicle_status_name: string | null;
};

export type CurrentVehicleState = {
  vehicle: ExchangeVehicle;
  fleetioStatusId: string;
  fleetioStatusName: string;
  endingOdometer: number;
  // GB only: where the returning vehicle is being left, written to Fleetio's
  // `vehicle_location` custom field (TP-6849). AU models location through Fleetio groups
  // and has no such field, so this stays empty there.
  returnLocation: string;
};

export const defaultExchangeVehicle: ExchangeVehicle = {
  id: '',
  make: '',
  model: '',
  year: '',
  color: '',
  license_plate: '',
  vin: '',
  current_meter_value: 0,
  body_type: '',
  group_ancestry: '',
  vehicle_status_name: null
};

export type CurrentVehicleAction =
  | { type: "SET_FLEETIO_STATUS"; payload: { id: string; name: string } }
  | { type: "SET_ENDING_ODOMETER"; payload: any }
  | { type: "SET_VEHICLE"; payload: IVehicle }
  | { type: "SET_RETURN_LOCATION"; payload: string };


export const currentVehicleInitialState: CurrentVehicleState = {
  vehicle: defaultExchangeVehicle,
  fleetioStatusId: "",
  fleetioStatusName: "",
  endingOdometer: 0,
  returnLocation: ""
};


export function currentVehicleReducer(
  state: CurrentVehicleState,
  action: CurrentVehicleAction
): CurrentVehicleState {
  switch (action.type) {
    case "SET_FLEETIO_STATUS":
      SentryLogger.debug(`Setting Fleetio status with id: ${action.payload.id} and name: ${action.payload.name}`);
      return {
        ...state,
        fleetioStatusId: action.payload.id,
        fleetioStatusName: action.payload.name,
      };
    case "SET_RETURN_LOCATION":
      SentryLogger.debug(`Setting vehicle return location: ${action.payload}`);
      return {
        ...state,
        returnLocation: action.payload,
      };
    case "SET_ENDING_ODOMETER":
      SentryLogger.debug(`Setting ending odometer with value: ${action.payload}`);
      return {
        ...state,
        endingOdometer: action.payload,
      };
    case "SET_VEHICLE":
      // convert IVehicle to ExchangeVehicle
      const convertedVehicle = {
        id: action.payload.id,
        make: action.payload.make,
        model: action.payload.model,
        year: action.payload.year,
        color: action.payload.color,
        license_plate: action.payload.license_plate,
        vin: action.payload.vin,
        current_meter_value: action.payload.current_meter_value,
        body_type: action.payload.specs?.body_type || '',
        group_ancestry: action.payload.group_ancestry || '',
        vehicle_status_name: action.payload.vehicle_status_name ?? null
      };
      return {...state, vehicle: convertedVehicle};
    default:
      console.error(`Error - incorrect action sent ${action} ${state}`)
      return state;
  }
}
